export { type BorderCanadaDocumentConfig, BorderCanadaDocumentConfigSchema } from "~/shared/documents/schemas/border-canada-config.schema";
